import { Col, Form, Row } from 'react-bootstrap';

const Step1 = ({ formData, setFormData }) => {
  return (
    <div className="card p-4">
      <h5 className="card-title mb-3">Step 1: Account Information</h5>
      <Form>
        {/* Type Section */}
        <h6 className="text-muted mb-3">Type</h6>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Label>Rate Class</Form.Label>
            <Form.Select
              value={formData.rateClass || ''}
              onChange={(e) => setFormData({ ...formData, rateClass: e.target.value })}
            >
              <option value="">Select Rate Class</option>
              <option value="Lifeline">Commercial</option>
              <option value="Regular">Residential</option>
            </Form.Select>
          </Col>
          <Col md={6}>
            <Form.Label>Customer Type</Form.Label>
            <Form.Select
              value={formData.customerType || ''}
              onChange={(e) => setFormData({ ...formData, customerType: e.target.value })}
            >
              <option value="">Select Customer Type</option>
              <option value="Lifeline">Lifeline</option>
              <option value="Regular">Regular</option>
            </Form.Select>
          </Col>
        </Row>

        {/* House Info Section */}
        <h6 className="text-muted mb-3">House Information</h6>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Label>Connected Load</Form.Label>
            <Form.Control
              type="text"
              placeholder="Connected Load"
              value={formData.connectedLoad || ''}
              onChange={(e) => setFormData({ ...formData, connectedLoad: e.target.value })}
            />
          </Col>
          <Col md={6}>
            <Form.Label>Property Ownership</Form.Label>
            <Form.Select
              value={formData.propertyOwnership || ''}
              onChange={(e) => setFormData({ ...formData, propertyOwnership: e.target.value })}
            >
              <option value="">Select Property Ownership</option>
              <option value="Owned">Owned</option>
              <option value="Rented">Rented</option>
            </Form.Select>
          </Col>
        </Row>

        {/* Person Info Section */}
        <h6 className="text-muted mb-3">Person Information</h6>
        <Row className="mb-3">
          <Col md={4}>
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Last Name"
              value={formData.lastName || ''}
              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
            />
          </Col>
          <Col md={4}>
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="First Name"
              value={formData.firstName || ''}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
            />
          </Col>
          <Col md={4}>
            <Form.Label>Middle Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Middle Name"
              value={formData.middleName || ''}
              onChange={(e) => setFormData({ ...formData, middleName: e.target.value })}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={4}>
            <Form.Label>Suffix (JR/III/etc.)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Suffix"
              value={formData.suffix || ''}
              onChange={(e) => setFormData({ ...formData, suffix: e.target.value })}
            />
          </Col>
          <Col md={4}>
            <Form.Label>Birthdate</Form.Label>
            <Form.Control
              type="date"
              value={formData.birthdate || ''}
              onChange={(e) => setFormData({ ...formData, birthdate: e.target.value })}
            />
          </Col>
          <Col md={4}>
            <Form.Label>Nationality</Form.Label>
            <Form.Select
              value={formData.nationality || ''}
              onChange={(e) => setFormData({ ...formData, nationality: e.target.value })}
            >
              <option value="">Select Nationality</option>
              <option value="Filipino">Filipino</option>
              <option value="Foreigner">Foreigner</option>
            </Form.Select>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Label>Sex</Form.Label>
            <Form.Select
              value={formData.sex || ''}
              onChange={(e) => setFormData({ ...formData, sex: e.target.value })}
            >
              <option value="">Select Sex</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </Form.Select>
          </Col>
          <Col md={6}>
            <Form.Label>Marital Status</Form.Label>
            <Form.Select
              value={formData.maritalStatus || ''}
              onChange={(e) => setFormData({ ...formData, maritalStatus: e.target.value })}
            >
              <option value="">Select Marital Status</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Widowed">Widowed</option>
              <option value="Divorced">Divorced</option>
            </Form.Select>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Step1;
